import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject
} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {ListResourceRS} from '../../app/core/service/listResourceRS.rest';
import {TSAdresse} from '../../models/entity/TSAdresse';
import {TSZahlungsinformationen} from '../../models/TSZahlungsinformationen';
import {TSLand} from '../../models/types/TSLand';
import {EbeguUtil} from '../../utils/EbeguUtil';
import {GesuchModelManager} from '../service/gesuchModelManager';

@Component({
    selector: 'dv-auszahlungsdaten',
    templateUrl: './auszahlungsdaten.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
    standalone: false
})
export class AuszahlungsdatenComponent implements OnInit {
    private readonly gesuchsmodelManager = inject(GesuchModelManager);
    private readonly listResourceRS = inject(ListResourceRS);

    @Input()
    public auszahlungsdaten: TSZahlungsinformationen;

    @Input()
    public auszahlungsdatenGS: TSZahlungsinformationen;

    @Input()
    public showAddress = false;

    @Output()
    public readonly auszahlungsdatenChange =
        new EventEmitter<TSZahlungsinformationen>();

    public laenderList: TSLand[];

    public ngOnInit(): void {
        this.listResourceRS.getLaenderList().then((laenderList: TSLand[]) => {
            this.laenderList = laenderList;
        });
    }

    public isReadOnly(): boolean {
        return this.gesuchsmodelManager.isGesuchReadonly();
    }

    public isKorrekturModusOrFreigegeben(): boolean {
        return this.gesuchsmodelManager.isKorrekturModusJugendamt();
    }

    public abweichendeZahlungsadresseChanged(): void {
        if (!this.auszahlungsdaten.abweichendeZahlungsadresse) {
            this.auszahlungsdaten.zahlungsadresse = null;
            return;
        }
        if (
            EbeguUtil.isNullOrUndefined(this.auszahlungsdaten.zahlungsadresse)
        ) {
            this.auszahlungsdaten.zahlungsadresse = new TSAdresse();
        }
    }
}
